export enum ExternalApplicationType {
	None = -3, // Initially to supported indicating that there is no HostedApplicationType
	// (ex. mAction surveys hosted within the mThrive application would return mAction, normal events would return None)
	All = -2, // Searching

	mSuite = 0,
	m360 = 1,
	mPerform = 2,
	mResearch = 3,
	mInterview = 4,
	mExit = 5,
	mThrive = 6,
	mAction = 7,
	mSpark = 8,
	Heat = 9,
	Routing = 10,
	mResearchSurveyEngine = 11,
	mCulture = 12,
	mChange = 13,
	mRisk = 14,
	MyReports = 15,
}
